import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  GetAllCategoriesAPI,
  GetAllSubCategoriesAPI,
  GetBranchCategoriesAPI,
  GetBranchSubCategoriesAPI,
} from "../../ApiRequests";

const branch = localStorage.getItem("branch");

export const fetchSubCategories = createAsyncThunk(
  "fetch/sub-category",
  async () => {
    try {
      let response;
      if (branch) {
        response = await GetBranchSubCategoriesAPI(branch);
      } else {
        response = await GetAllSubCategoriesAPI();
      }
      if (!response.data?.success) {
        showErrorToast(response.data.error.msg);
      } else if (response.data?.success) {
        return response.data.data.payload;
      }
    } catch (error) {
      console.log(error);
    }
    return [];
  }
);

const SubCategorySlice = createSlice({
  name: "sub-category-data",
  initialState: {
    loading: false,
    data: [],
    isError: false,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchSubCategories.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(fetchSubCategories.fulfilled, (state, action) => {
      state.loading = false;
      state.data = action.payload;
    });
    builder.addCase(fetchSubCategories.rejected, (state, action) => {
      state.isError = true;
      console.log("Error: ", action.error);
    });
  },
});

export default SubCategorySlice.reducer;
